import React from 'react';

const About = () => {
    return (
        <div>
            <h1 className='text-4xl' >This is about</h1>
        </div>
    );
};

export default About;